import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const templateStatusesCriterionRoute: RouteConfig = {
  path: ':statusId/criterions',
  name: 'statusCriterionList',
  component: () =>
    import(/* webpackChunkName: "StatusCriterion" */ '@/views/mainRoute/template/steps/StatusCriterions.vue'),
  meta: {
    breadcrumb: {
      title: 'Kryteria statusu'
    }
  },
  beforeEnter: (to, from, next) => {
    store
      .dispatch('criterion/list', { statusId: tryParseInt(to.params.statusId), rootOnly: true })
      .then(() => next())
      .catch((err: any) => store.dispatch('notifyError', { title: Errors.CRITERION_CANNOT_LIST }));
  }
};
